import React from 'react'
import { BasicFormLayout, Form } from '@carsys/form'
import * as Yup from 'yup'
import General from 'app-support/themes/components/General'
import { Typography } from '@mui/material'

export interface IThemeFormValues {
  UUID?: string
  IsActive: boolean
  LogoURL: string
  LogoSmallURL: string
  Name: string
  MainColour: string
  MainColourText: string
}
interface IThemeFormProps {
  title: string
  showDialogOnSave?: boolean
  confirmationRequired?: boolean
  dialogText?: string
  redirectToURL?: string
  initialValues: IThemeFormValues
  onSubmit: (formValues: IThemeFormValues) => Promise<IThemeFormValues>
  onSubmitSuccess: (formValues: IThemeFormValues) => void
  onSubmitAndDone: (values: any) => Promise<string | void>
}

const ThemeForm: React.FC<IThemeFormProps> = ({ title, initialValues, onSubmit, onSubmitSuccess, redirectToURL, confirmationRequired }) => {
  const validationSchema = Yup.object().shape({
    Name: Yup.string().required(),
    MainColour: Yup.string().optional(),
    MainColourText: Yup.string().optional(),
    IsActive: Yup.boolean().optional(),
    LogoURL: Yup.string().required(),
    LogoSmallURL: Yup.string().required()
  })

  return (
    <Form
      confirmationRequired={confirmationRequired}
      initialValues={initialValues}
      onSubmit={onSubmit}
      onSubmitSuccess={onSubmitSuccess}
      validationSchema={validationSchema}
    >
      <BasicFormLayout title={<Typography variant='h6'>{title}</Typography>} backButtonProps={{ to: () => redirectToURL || '' }}>
        <General />
      </BasicFormLayout>
    </Form>
  )
}
ThemeForm.displayName = 'ThemeForm'

export default ThemeForm
